/* eslint-disable */

<template>
 <v-container class="my-0 pt-1 pb-0 px-0">
        <v-row no-gutters v-if="c_loading" class="pa-2 ma-0">
            <v-progress-circular
                    indeterminate
                    size="64"
                    width="7"
                    color="primary"
                    ></v-progress-circular>
        </v-row>
        <v-row no-gutters v-else class="flex-row" pa-0 ma-0 >
            <v-col cols="12" sm="12" md="2" class="d-flex align-start justify-end order-xs-1 order-sm-1 order-md-2 pb-0">
                <slot name="other_action"></slot>
                <v-btn
                    color="primary"
                    fab
                    small
                    v-can="{obj_type:'client', action: 'remove'}"
                ><v-icon class="ma-2" small @click.stop="openDeleteConfirm">delete</v-icon></v-btn>
            </v-col>
            <v-col cols="12" sm="12" md="10" class="d-flex align-start justify-start order-xs-2 order-sm-2 order-md-1 pb-1 cursor_pointer" @click.stop.prevent="goToClientDetails">
                <div width="100%" class="d-flex align-start justify-center fill-height">
                    <div class="d-flex flex-grow-1 flex-shrink-0 text-left ml-2">
                        <span><b>{{ client.name }}</b> - PIVA: {{client.piva}} <br/>
                        <b>Sede legale: </b>
                        <span v-if="!!location && !location.dismissed">{{ location.city }} ({{ location.district }}) - {{ location.address}} {{ location.addrNum }}<br/>
                        </span>
                        <span v-else>-</span></span>
                    </div>
                </div>
            </v-col>
        </v-row>
    <ConfirmDialog
        v-bind:data="delete_confirm"
        v-on:close_dialog="closeDialog"
        v-on:confirm_result="onDeleteConfirm"/>
        
    </v-container>
</template>
<script>
// import _ from 'lodash'

import ConfirmDialog from '../../components/dialogs/ConfirmDialog'
import { searchDesign } from "../../utils/dbUtility"

export default {
    components: {ConfirmDialog},
    props: [
        "client_id"
    ],
    data(){
        return {
            operation: {},
            client:{},
            location:{},
            delete_confirm: {
                index: null,
                dialog: false,
                doc: null,
                title: 'Elimina cliente',
                message: "Sei sicuro di voler rimuovere il cliente selezionato?",
                choices: [
                    {key: "cancel", val: "annulla", mod: "success"},
                    {key: "delete", val: "elimina"}
                    ]
            },
            op_date_str: "",
            c_loading: false,
            deletable: false
        }
    },
    computed: {
        
    },
    async mounted() {
        await this.loadClient()
    },
    beforeDestroy() {
        this.operation = null
        this.client = null
        this.location = null
        this.delete_confirm = null 
    },
    methods: {
        async isDeletable() {
            var loc_search = await searchDesign(this.$store.state.$pouch, 'registry', 'registry/searchByData', 'key', ['client', this.client_id], true)
            var instr_search = await searchDesign(this.$store.state.$pouch, 'registry','instruments/searchByData', 'key', ['client', this.client_id], true)
            var loc_count = (loc_search.length > 0) ? loc_search[0].value : 0
            var instr_count = (instr_search.length > 0) ? instr_search[0].value : 0
            //console.log("COUNTERS", loc_count, instr_count)
            this.deletable = (loc_count== 0) && (instr_count==0)
        },
        async loadClient() {
            this.c_loading = true
            this.client = await this.$store.state.$pouch.get('registry', this.client_id)
            // console.log('CLIENT_ID', this.client_id)
            this.isDeletable()
            if (this.client.registered_office) {
                try {
                    this.location = await this.$store.state.$pouch.get('registry', this.client.registered_office)
                } catch(err) {
                    console.log('ERROR', err)
                    this.location = null
                }
            } else {
                this.location = null
            }
            this.c_loading = false
        },
        async openDeleteConfirm(){
            // console.log('DELETE', index, doc)
            await this.isDeletable()
            if (this.deletable) {
                this.delete_confirm.dialog = true;
            } else  {
                this.$store.commit("showSnackbar", {text: "Cliente non cancellabile: sono ancora presenti sedi e strumenti", color: 'error'})
            }
        },
        async onDeleteConfirm(choice){
            try{
                if(choice == "delete"){
                    this.client.updated_by = this.$store.state.user._id
                    this.client.updated = (new Date()).getTime()
                    // this.client._deleted = true
                    this.client.dismissed = true
                    await this.$store.state.$pouch.put('registry', this.client)
                    this.$emit('client_removed')
                    this.$store.commit("showSnackbar", {text: "Cliente rimosso con successo", color: 'primary'})
                }
                this.closeDialog()
            } catch(error) {
                console.log('error', error)
            }
        },
        closeDialog(){
            this.delete_confirm.dialog = false;
        },
        goToClientDetails() {
            console.log('GO TO CLIENT DETAILS *****')
            this.$router.push({path: "/clients/details", query: {"client_id": this.client._id, "back": this.$router.history.current.fullPath}})
        }
    },
    
}

</script>